import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";


// constants
import { ReactIcons, MuiIcons } from "../../icons";
import { USER_KEY } from "../../const";
import "./setting.css";
import { useSelector } from "react-redux";

function Setting() {
  const history = useHistory();
  const user_data = JSON.parse(localStorage.getItem(USER_KEY));
  const [role, setRole] = useState();

  // get permission from redux
  const { rolePermissions } = useSelector((state) => state.permissions);

  useEffect(() => {
    if (user_data) {
      setRole(user_data?.data?.role);
    }
  }, [user_data]);

  const itemsSettingAdmin = [
    {
      title: "ໂປຣຟາຍ",
      icon: <MuiIcons.AccountCircleIcon sx={{ fontSize: 34 }} />,
      path: "/settings/profile",
      document: "ຂໍ້ມູນໂປຣຟາຍຂອງຜູ້ເຂົ້ານຳໃຊ້ລະບົບ"
    },
    {
      title: "ປະເພດສິນຄ້າ",
      icon: <MuiIcons.BorderAllOutlinedIcon sx={{ fontSize: 34 }} />,
      path: "/settings/producttype/limit/50/page/1",
      document: "ເພິ່ມຕັ້ງຄ່າປະເພດ ສິນຄ້າ ໃນຮ້ານຂອງທ່ານ"
    },
    {
      title: "ເເບນ",
      icon: <MuiIcons.AnnouncementOutlinedIcon sx={{ fontSize: 34 }} />,
      path: "/settings/brand/limit/50/page/1",
      document: "ຈັດການ ຕັ້ງຄ່າແບຣນ"
    },
    // {
    //   title: "ຊັບເເບນ",
    //   icon: <MuiIcons.AnnouncementOutlinedIcon sx={{ fontSize: 34 }} />,
    //   path: "/settings/subbrand/limit/50/page/1",
    //   document: "ສຳຫລັບການຕັ້ງຄ່າຊັບແບຣນ"
    // },
    {
      title: "ຕົວເລືອກ",
      icon: <MuiIcons.SwapVertIcon sx={{ fontSize: 34 }} />,
      path: "/settings/option",
      document: "ຫົວໜ່ວຍ, ເລກລອດ"
    },
    {
      title: "ເລດເງີນ",
      icon: <MuiIcons.PriceChangeOutlinedIcon sx={{ fontSize: 34 }} />,
      path: "/exchangerate",
      document: "ກຳນົດເລດເງິນໃນການຂາຍສິນຄ້າ"
    },
    {
      title: "ປິນເຕີ",
      icon: <MuiIcons.PrintIcon sx={{ fontSize: 34 }} />,
      path: "/printer/limit/50/page/1",
      document: "ການຕັ້ງຄ່າກ່ຽວກັບປິນເຕີ ໃນລະບົບ"
    },
    {
      title: "ສ້າງບາໂຄດ",
      icon: <ReactIcons.AiOutlineBarcode size={34} />,
      path: "/settings/barcode/limit/50/page/1",
      document: "ຕັ້ງຄ່າ ສຳຫລັບບາໂຄດ ສິນຄ້າ"
    },
    {
      title: "ຈັດການລູກຄ້າ",
      icon: <MuiIcons.GroupAddIcon sx={{ fontSize: 34 }} />,
      path: "/settings/customer/limit/50/page/1",
      document: "ຂໍ້ມູນຂອງລູກຄ້າທົງໝົດ"
    },
    {
      title: "ບັນຊີ",
      icon: <MuiIcons.AccountBalanceWalletIcon sx={{ fontSize: 34 }} />,
      path: "/settings/bank",
      document: "ຕັ້ງຄ່າບັນຊີ ທະນາຄານ"
    },
    {
      title: "ຈັດການພະນັກງານ",
      icon: <ReactIcons.FaUsers style={{ fontSize: 34 }} />,
      path: "/settings/User",
      document: "ການຕັ້ງຄ່າ ສຳຫລັບພະນັກງານນຳໃຊ້ລະບົບ",
      isPermission: "STAFF_MANAGEMENT",
    },
    {
      title: "ຈັດການຂອງລາງວັນ",
      icon: <ReactIcons.BsGiftFill style={{ fontSize: 34 }} />,
      path: "/settings/reward",
      document: "ການຕັ້ງຄ່າ ການຄຳນວນຄະແນນ & ຂອງລາງວັນ",
      isPermission: "STAFF_MANAGEMENT",
    },

    {
      title: "ບິນ",
      icon: <ReactIcons.TbFileInvoice style={{ fontSize: 34 }} />,
      path: "/settings/bill_setting",
      document: "ໃບບິນເກັບເງິນ, ໃບສະເໜີລາຄາ"
    },
    {
      title: "ສິດນຳໃຊ້ລະບົບ",
      icon: <ReactIcons.MdPrivacyTip style={{ fontSize: 34 }} />,
      path: "/settings/role",
      newFeature: false,
      document: "ກຳນົດສິດນຳໃຊ້ລະບົບ",
      isPermission: "STAFF_MANAGEMENT",
    },
    {
      title: "ພາສາ",
      icon: <ReactIcons.IoLanguage style={{ fontSize: 34 }} />,
      path: "/settings/language",
      newFeature: false,
      document: "ກຳນົດພາສາໃນລະບົບ",
    },
    {
      title: "ຕັ້ງຄ່າຮ້ານ",
      icon: <MuiIcons.AddBusinessIcon sx={{ fontSize: 34 }} />,
      path: {
        pathname: `/settings/shop:${user_data?.data?.shop?.id}`,
        state: { shop: user_data?.data?.shop }
      },
      newFeature: true,
      document: "ຂໍ້ມູນກ່ຽວກັບການຂາຍ",
    }
  ];

  // check role and permission
  const isAdmin = role === "ADMIN";

  return (
    <div style={{ height: 'auto', minHeight: '100vh', padding: 20 }}>
      <h5>ຕັ້ງຄ່າ</h5>
      <p>ຂໍ້ມູນການຕັ້ງຄ່າ</p>
      <div className="card-setting">
        {itemsSettingAdmin
          .filter(item => isAdmin || !item.isPermission || rolePermissions.includes(item.isPermission))
          .map((item, index) => (
            <div className="card-item" key={index} onClick={() => history.push(item?.path)}>
              {item?.newFeature &&
                <span className="newFeature-text">New</span>
              }
              <div>{item?.icon}</div>
              <h4>{item?.title}</h4>
              <p style={{fontWeight: "normal", marginTop: -5}}>{item?.document}</p>
            </div>
          ))}

      </div>
    </div>
  );
}

export default Setting;